import PropTypes from 'prop-types';
import * as dateHelper from '../../../../common/services/date-helper/service';
import { getCurrentUser } from '../../../services/CurrentUser';

export default function DateDisplayMinimal({
    date,
    tooltipPos = 'oneline',
    className = '',
    style = {},
    withTooltip = true,
}) {
    const companySettings = getCurrentUser().company.companySettings;
    const minimalDate = dateHelper.toMinimalDate(date, companySettings);
    const tooltipDate = dateHelper.descriptiveDate(date, companySettings);
    return (
        <span
            data-tooltip={withTooltip ? tooltipDate : null}
            data-tooltip-options={tooltipPos}
            className={className}
            style={style}
        >
            {minimalDate}
        </span>
    );
}

DateDisplayMinimal.propTypes = {
    date: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    tooltipPos: PropTypes.string,
};
